module.exports = __webpack_public_path__ + "img/tm.3d54ae96.svg";